import { type PlanCardItem } from "@/components/feature/PlanCards";

interface VpsComparisonTableProps {
  plans: PlanCardItem[];
}

const SPEC_ROWS: { label: string; icon: string }[] = [
  { label: "Memória", icon: "ri-database-2-line" },
  { label: "Disco", icon: "ri-hard-drive-2-line" },
  { label: "CPU", icon: "ri-cpu-line" },
  { label: "Tráfego", icon: "ri-exchange-line" },
];

function specValue(plan: PlanCardItem, label: string): string {
  return plan.specs?.find((spec) => spec.label === label)?.value ?? "—";
}

export default function VpsComparisonTable({ plans }: VpsComparisonTableProps) {
  if (plans.length === 0) return null;

  return (
    <div className="overflow-x-auto rounded-xl border border-background-200 bg-background-50">
      <table className="w-full border-collapse text-sm">
        <caption className="sr-only">Comparativo lado a lado dos planos de VPS</caption>
        <thead>
          <tr>
            <th
              scope="col"
              className="sticky left-0 z-10 border-b border-background-200 bg-background-100 p-4 text-left align-bottom"
            >
              <span className="text-xs font-semibold uppercase tracking-wide text-foreground-500">
                Plano
              </span>
            </th>
            {plans.map((plan) => (
              <th
                key={plan.name}
                scope="col"
                className="min-w-[150px] border-b border-l border-background-200 bg-background-100 p-4 text-left align-bottom"
              >
                <span className="block font-heading text-sm font-semibold text-foreground-950">
                  {plan.name}
                </span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <th
              scope="row"
              className="sticky left-0 z-10 border-b border-background-200 bg-background-50 p-4 text-left"
            >
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-foreground-500">
                <i className="ri-price-tag-3-line" aria-hidden="true"></i>
                Preço
              </span>
            </th>
            {plans.map((plan) => (
              <td
                key={plan.name}
                className="border-b border-l border-background-200 bg-background-50 p-4"
              >
                <span className="font-heading text-base font-bold text-primary-600">
                  R$ {plan.price}
                </span>
                <span className="text-xs text-foreground-500">{plan.unit ?? "/mês"}</span>
              </td>
            ))}
          </tr>

          {SPEC_ROWS.map((row) => (
            <tr key={row.label}>
              <th
                scope="row"
                className="sticky left-0 z-10 border-b border-background-200 bg-background-50 p-4 text-left"
              >
                <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-foreground-500">
                  <i className={row.icon} aria-hidden="true"></i>
                  {row.label}
                </span>
              </th>
              {plans.map((plan) => (
                <td
                  key={plan.name}
                  className="border-b border-l border-background-200 bg-background-50 p-4 text-foreground-800"
                >
                  {specValue(plan, row.label)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}